import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SystemConstant, LangConstant } from "const";
import { useBranchRequestUpdate } from "hooks";
import FormUpdateBranchRequest from "./FormUpdateBranchRequest";

const BranchRequestStatus = ({ user, refetch }) => {
  const { t: getLabel } = useTranslation();
  const status = user ? user.status : 0;

  const { updateBranchRequest } = useBranchRequestUpdate();

  const [isOpenConfirmCancleReject, setIsOpenConfirmCancleReject] = useState(false);
  const [isOpenConfirmReject, setIsOpenConfirmReject] = useState(false);
  const [isOpenFormAccept, setIsOpenFormAccept] = useState(false);

  const handleCancleReject = () => {
    updateBranchRequest({
      branch_request_ids: [user.id],
      status: SystemConstant.BRANCH_REQUEST_STATUS.PENDING.status,
      refetch: refetch,
      onClose: () => {
        setIsOpenConfirmCancleReject(false);
      },
    });
  };

  const handleReject = () => {
    updateBranchRequest({
      branch_request_ids: [user.id],
      status: SystemConstant.BRANCH_REQUEST_STATUS.REJECTED.status,
      refetch: refetch,
      onClose: () => {
        setIsOpenConfirmReject(false);
        setIsOpenFormAccept(false);
      },
    });
  };

  const onCloseForm = () => {
    setIsOpenFormAccept(false);
  };

  const DialogConfirmCancleReject = () => {
    if (!isOpenConfirmCancleReject) return null;
    return (
      <>
        <div className="modal-backdrop fade show" />
        <div className="modal modal-sm show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h5 className="modal-title fw-bold">{getLabel(LangConstant.TXT_REQUEST_CONFIRM_REMOVE_REJECT)}</h5>
              </div>
              <div className="modal-body text-center">
                <p>{getLabel(LangConstant.TXT_REQUEST_CONFIRM_REMOVE_REJECT_CONTENT, { phone: user.phone })}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-link link-secondary me-auto"
                  onClick={() => setIsOpenConfirmCancleReject(false)}
                >
                  {getLabel(LangConstant.L_CANCEL)}
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleCancleReject}
                >
                  {getLabel(LangConstant.L_CONFIRM_BUTTON)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const DialogConfirmReject = () => {
    if (!isOpenConfirmReject) return null;
    return (
      <>
        <div className="modal-backdrop fade show" />
        <div className="modal modal-sm show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h5 className="modal-title fw-bold">{getLabel(LangConstant.TXT_REQUEST_REJECT_TITLE)}</h5>
              </div>
              <div className="modal-body text-center">
                <p>{getLabel(LangConstant.TXT_REQUEST_REJECT_CONTENT, { phone: user.phone })}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-link link-secondary me-auto"
                  onClick={() => setIsOpenConfirmReject(false)}
                >
                  {getLabel(LangConstant.L_CANCEL)}
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleReject}
                >
                  {getLabel(LangConstant.L_CONFIRM_BUTTON)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const StatusLabel = () => {
    switch (status) {
      case SystemConstant.BRANCH_REQUEST_STATUS.PENDING.status:
        return (
          <span
            className="badge bg-warning-lt"
            style={{ cursor: "pointer", width: 130, border: "1px solid #FFD402", color: "#FFD402" }}
            onClick={() => setIsOpenFormAccept(true)}
          >
            {getLabel(SystemConstant.BRANCH_REQUEST_STATUS.PENDING.label)}
          </span>
        );
      default:
        return (
          <span
            className="badge bg-danger-lt"
            style={{ cursor: "pointer", width: 130 }}
            onClick={() => setIsOpenConfirmCancleReject(true)}
          >
            {getLabel(SystemConstant.BRANCH_REQUEST_STATUS.REJECTED.label)}
          </span>
        );
    }
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <StatusLabel />
      <DialogConfirmCancleReject />
      <FormUpdateBranchRequest
        user={user}
        isOpenFormAccept={isOpenFormAccept}
        onCloseForm={onCloseForm}
        onOpenConfirm={() => setIsOpenConfirmReject(true)}
        refetch={refetch}
      />
      <DialogConfirmReject />
    </div>
  );
};

export default BranchRequestStatus;
